<template>
  <!-- eslint-disable -->
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 1200 1200">
    <path 
      :fill="fill"
      fill-rule="nonzero"
      d="M50,77.054l12.185,197.532c481.644-0.74,880.361,376.093,898.81,833.157L1150,1104.61C1131.466,543.866,643.032,76.925,50,77.054z M68.187,439.184l11.922,193.829c117.821-1.564,250.875,58.262,353.032,153.633c101.813,93.936,168.906,218.895,173.691,330.844l191.178-3.132C775.734,766.107,436.71,444.579,68.187,439.184z M191.056,852.216c-77.443,0.913-136.529,62.78-131.744,137.879c4.611,74.792,70.835,134.097,147.672,132.831c76.663-1.345,135.571-62.348,131.481-136.877C334.375,911.213,268.329,851.258,191.056,852.216z"
    />
  </svg>
</template>

<script>
export default {
  props: {
    fill: {
      default: '#94979B',
      type: String,
    },
  },
};
</script>
